/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PcczScoreDto } from '../../models/pccz-score-dto';

export interface LpInspectionControllerGetPcczScore$Params {
  id: string;
}

export function lpInspectionControllerGetPcczScore(http: HttpClient, rootUrl: string, params: LpInspectionControllerGetPcczScore$Params, context?: HttpContext): Observable<StrictHttpResponse<PcczScoreDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionControllerGetPcczScore.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PcczScoreDto>;
    })
  );
}

lpInspectionControllerGetPcczScore.PATH = '/api/lp-inspection/{id}/zscore';
